module.exports = __webpack_public_path__ + "media/images/icon-lw-8e07fa0880d0827c738a135398780b0e.svg";